import { Assert } from "@/common/Assert";
export function createScormApiForLessons(course) {
    Assert.checkArgument(course);
    // revealing public api
    return {
        Initialize: () => course.hasActiveLearningSco() ? "true" : "false",
        Terminate: () => {
            course.terminateActiveLearningSco();
            return "true";
        },
        GetValue: (key) => {
            const activeSco = course.getActiveLearningSco();
            if (!activeSco) {
                return "false";
            }
            switch (key) {
                case "cmi.entry":
                    return "ab-initio";
                case "cmi.location":
                case "cmi.success_status":
                case "cmi.completion_status":
                case "cmi.lesson_mode":
                case "cmi.score.raw":
                case "cmi.core.score.scaled":
                case "cmi.suspend_data":
                    return activeSco.getValue(key);
                default:
                    const value = course.getValue(key);
                    return value ? value : "";
            }
        },
        SetValue: (key, value) => {
            const activeSco = course.getActiveLearningSco();
            if (!activeSco) {
                return "false";
            }
            switch (key) {
                case "cmi.location":
                case "cmi.success_status":
                case "cmi.completion_status":
                case "cmi.entry":
                case "cmi.session_time":
                case "cmi.suspend_data":
                    activeSco.setValue(key, value);
                    return "true";
                case "cmi.score.raw":
                    activeSco.updateScore(value);
                    return "true";
                case "cmi.core.score.scaled":
                    const rawScore = (parseInt(value) * 100).toString();
                    activeSco.updateScore(rawScore);
                    return "true";
                default:
                    return course.setValue(key, value) ? "true" : "false";
            }
        },
        Commit: () => {
            if (course.hasActiveLearningSco()) {
                course.commit();
                return "true";
            }
            return "false";
        },
        GetLastError: () => "0",
        GetErrorString: () => "",
        GetDiagnostic: () => ""
    };
}
